import React, { Component } from 'react'

import SortableTable from './SortableTable'

import './RidingTable.css'

import { formatNumber } from '../../formatter'

import { POWER_PROJECT_TYPES, POWER_TOTAL } from '../../models/PowerProject'
import { Link } from 'react-router-dom'

class RidingTable extends Component {
  render () {
    let baseColumns = []

    if (this.props.showProvince) {
      baseColumns.push({
        id: 'province',
        name: 'Province',
        accessor: d => [d.province, d.provinceCode],
        displayAccessor: d => d.provinceCode,
        headerClass: 'narrow',
        filterable: true,
        onlyFilterFromStart: true
      })
    }

    baseColumns = baseColumns.concat([
      { id: 'name',
        name: 'Riding',
        accessor: d => d.name,
        displayAccessor: d => <Link to={d.URL()}>{d.name}</Link>,
        filterable: true
      },
      { id: 'partyCode',
        name: 'Party',
        accessor: d => `${d.party} ${d.partyShortName}`,
        displayAccessor: d => d.partyShortName,
        headerClass: 'narrow',
        filterable: true
      },
      { id: 'repName',
        name: 'Representative',
        accessor: d => d.rep.name,
        filterable: true
      }
    ])

    // For the purposes of this listing only, combine Tidal and Pumped Storage
    // under 'Other'
    const powerProjectTypes = Object.assign({}, POWER_PROJECT_TYPES)
    delete powerProjectTypes['Tidal']
    delete powerProjectTypes['Pumped Storage']

    const accessor = (key, datum) => {
      let total = datum.powerProjectStat(key).totalMW
      if (key === 'Other') {
        total += datum.powerProjectStat('Tidal').totalMW
        total += datum.powerProjectStat('Pumped Storage').totalMW
      }
      return total
    }

    const powerColumns = Object.keys(powerProjectTypes).map(k => {
      const icon = POWER_PROJECT_TYPES[k].icon
      const colHeader = (
        <span>
          <i className={`icon normal-weight ${icon}`} />
          <span className='tiny'>{POWER_PROJECT_TYPES[k].shortName}</span>
          {' '}MW
        </span>
      )
      return {
        id: k,
        name: colHeader,
        cellClass: 'text-right',
        headerClass: 'text-center',
        accessor: d => accessor(k, d),
        displayAccessor: d => formatNumber(accessor(k, d)),
        sortDescFirst: true
      }
    })

    powerColumns.push({
      id: 'totalPower',
      name: (<span>
        <i className={`icon fa fa-bolt`} />
        <span className='tiny'>Total</span>
        {' '}MW
      </span>),
      cellClass: 'text-right',
      headerClass: 'text-center',
      accessor: d => d.powerProjectStat(POWER_TOTAL).totalMW,
      displayAccessor: d => formatNumber(d.powerProjectStat(POWER_TOTAL).totalMW),
      sortDescFirst: true
    })

    const columns = baseColumns.concat(powerColumns)

    const rowFilter = (r) => true

    const ridings = this.props.ridings
      ? Object.values(this.props.ridings)
      : []

    return (
      <div id={this.props.id} className='RidingTable margin-top'>
        <SortableTable
          columns={columns}
          baseSortColumnId={'partyCode'}
          rows={ridings}
          rowFilter={rowFilter}
        />
      </div>
    )
  }
}

export default RidingTable



// WEBPACK FOOTER //
// ./src/components/Tables/RidingTable.js